var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "how-works" } }, [
    _c("div", { staticClass: "container" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-6" }, [
          _c(
            "div",
            { staticClass: "icon" },
            [
              _c("font-awesome-icon", {
                staticClass: "fa",
                attrs: { icon: ["fas", "users"], size: "lg" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("h4", [_vm._v("O que nos move é a compaixão")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n          Somos apaixonados por pessoas. Queremos dar voz às Organizações Sociais e transformar vidas. \n          Criar abundância de sonhos e transformações. \n          Acreditamos que a soma pode trazer paz ao desespero, esperança ao abandono e felicidade à tristeza.\n        "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6" }, [
          _c(
            "div",
            { staticClass: "icon" },
            [
              _c("font-awesome-icon", {
                staticClass: "fa",
                attrs: { icon: ["fas", "donate"], size: "lg" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("h4", [_vm._v("Fazer o bem , faz bem para você!")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n          Doação é quando fazemos o bem para o próximo sem esperar nada em troca. \n          Quando ajudamos ao próximo estamos ajudando a nós mesmos. A soma de pequenas doações faz a diferença na vida de muita gente.\n          Nossa plataforma permite doações de forma pontual ou recorrente, através de diferentes meios de pagamentos, como cartões de crédito, débito e boleto bancário.\n        "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-6" }, [
          _c(
            "div",
            { staticClass: "icon" },
            [
              _c("font-awesome-icon", {
                staticClass: "fa",
                attrs: { icon: ["fas", "desktop"], size: "lg" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("h4", [_vm._v("Plataforma Digital")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n          Ferramentas de comunicação, relacionamento e divulgação, integrada à redes sociais em um único ambiente.\n          Fácil de usar e simples como deve ser. Acreditamos no poder da comunicação para ampliar o conceito de doação, engajamento e fraternidade.\n        "
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-6" }, [
          _c(
            "div",
            { staticClass: "icon" },
            [
              _c("font-awesome-icon", {
                staticClass: "fa",
                attrs: { icon: ["fas", "share-square"], size: "lg" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("h4", [_vm._v("Compartilhe e receba atualizações")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n          Acreditamos que cada um é tocado por algo diferente. \n          Escolha uma categoria, conheça as Organizações Sociais, assista aos vídeos e ajude como puder.\n          Compartilhe com seus amigos, receba atualizações e colabore na divulgação da Organização Social que você admira.\n        "
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("h2", [
        _vm._v(
          "A Click2Giv quer empoderar quem faz e quer fazer ainda mais o bem."
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-090faeb3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-090faeb3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/HowWorksSection.vue
// module id = null
// module chunks = 